<template>
    <div data-testid="client-tasks">
        <div class="card-header">
            <div class="row">
                <div class="col-md-2">
                    Filtrování
                </div>
                <div class="col-md-7 text-center">
                    <button class="btn btn-sm btn-outline-danger" value="scheduled" v-if="selectedStates.indexOf('scheduled') < 0" @click="selectedStates.push('scheduled')" data-testid="client-tasks-filter-scheduled">plánovaní</button>
                    <button class="btn btn-sm btn-success" value="scheduled" v-else="" @click="selectedStates.splice(selectedStates.indexOf('scheduled'), 1)" data-testid="client-tasks-filter-scheduled">plánovaní</button>

                    <button class="btn btn-sm btn-outline-danger" value="completed" v-if="selectedStates.indexOf('completed') < 0" @click="selectedStates.push('completed')" data-testid="client-tasks-filter-completed">splněno</button>
                    <button class="btn btn-sm btn-success" value="completed" v-else="" @click="selectedStates.splice(selectedStates.indexOf('completed'), 1)" data-testid="client-tasks-filter-completed">splněno</button>

                    <button class="btn btn-sm btn-outline-danger" value="canceled" v-if="selectedStates.indexOf('canceled') < 0" @click="selectedStates.push('canceled')" data-testid="client-tasks-filter-canceled">zrušeno</button>
                    <button class="btn btn-sm btn-success" value="canceled" v-else="" @click="selectedStates.splice(selectedStates.indexOf('canceled'), 1)" data-testid="client-tasks-filter-canceled">zrušeno</button>
                </div>
                <div class="col-md-3 text-right">
                    <button @click="updateVisits" class="btn btn-secondary btn-sm" data-testid="client-tasks-refresh"><i class="fa fa-refresh"></i></button>
                    <button class="btn btn-sm btn-outline-success" @click="showModalClientTaskAdd" data-testid="client-task-add-open"> <i class="fa fa-calendar-plus-o" aria-hidden="true"></i> naplánovat úkol</button>
                </div>
            </div>
        </div>

        <div class="card-body" v-if="visits.length > 0">
            <table class="table">
                <thead>
                <tr>
                    <th></th>
                    <th>Datum / čas<br>Klient</th>
                    <th></th>
                    <th>Důvod návštěvy</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(visit, index) in (visits)" class="card-text">
                    <tr :data-testid="'client-task-' + visit.id">
                        <td rowspan="2" class="align-middle">
                            <visit-task-change-state-receptionist v-if="hasRole('receptionist')" v-on:update="updateVisits" :actual-state="visit.state" :selected-doctor-id="visit.planned_for.id" :visit-id="visit.id" test-prefix="client-task"></visit-task-change-state-receptionist>
                            <visit-task-change-state-doctor v-else-if="hasRole('doctor')" v-on:update="updateVisits" :actual-state="visit.state" :selected-doctor-id="visit.planned_for.id" :visit-id="visit.id" test-prefix="client-task"></visit-task-change-state-doctor>
                        </td>
                        <td class="align-middle">
                            <template v-if="visit.hasData">
                                <button @click="showHideVisitDetail(index)" class="btn btn-sm btn_extra_small btn-primary" :data-testid="'client-task-detail-' + visit.id"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
                            </template>
                            <router-link :to="{ name: 'ShowVisit', params: { clientid: $route.params.clientid, visitid: visit.id }}" v-if="hasLoggedUserRole('doctor')">
                                {{ visit.date }}
                            </router-link>
                            <template v-else>
                                {{ visit.date }}
                            </template>
                        </td>
                        <td>

                        </td>
                        <td colspan="2" class="align-middle">
                            <b>{{ visit.visit_purpose.purpose }}</b>
                            <template v-if="editingVisitId === visit.id "><label for="note">poznámka: </label>
                                <form class="form-inline" @submit.prevent="putVisit(visit)">
                                    <input v-model="editingVisit.note" type="text" class="form-control ml-sm-1 col-sm-10 mr-sm-2" aria-describedby="noteHelp" id="note" :data-testid="'client-task-note-' + visit.id">
                                    <button v-if="!waitForSave" type="submit" class="btn btn-primary" :data-testid="'client-task-save-' + visit.id">Uložit</button>
                                    <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                                </form>
                            </template>
                            <template v-else=""><button @click="editVisit(visit.note, visit.id)" class="btn btn-sm btn-link text-secondary" :data-testid="'client-task-edit-' + visit.id"><i class="fa fa-pencil" aria-hidden="true"></i></button><i>poznámka: {{ visit.note }}</i></template>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3" class="border-top-0">
                            <!--<router-link class="text-secondary" :to="{ name: 'ShowClient', params: { clientid: visit.client.id }}"><i class="fa fa-address-card-o" aria-hidden="true"></i></router-link> {{ visit.client.first_name }} {{ visit.client.last_name }} - {{ visit.client.p_i_n }}-->
                            <!--<span class="badge badge-secondary" v-if="visit.client.health_insurance">{{ visit.client.health_insurance.code }}</span>
                            <span class="badge badge-warning" v-else=""><i class="fa fa-warning" aria-hidden="true"></i> chybí zdrav. pojišťovna</span>
                            <span class="badge badge-primary" v-if="visit.client.membership">{{ visit.client.membership.name }}</span>
                            <span class="badge badge-warning" v-else=""><i class="fa fa-warning" aria-hidden="true"></i> nemá program</span>
                            <span class="badge badge-warning" v-if="visit.client.missing_data"><i class="fa fa-danger" aria-hidden="true"></i> chybějící údaje</span>
                            <span class="badge badge-warning" v-if="visit.client.missing_contact"><i class="fa fa-danger" aria-hidden="true"></i> chybějící kontakty</span>-->
                        </td>
                        <td colspan="1" class="border-top-0 text-right">
                            <template v-if="visit.state === 'scheduled'">
                                <!-- <button class="btn btn-sm btn-warning" @click="showModalClientVisitChange(visit.id)"><i class="fa fa-calendar-plus-o" aria-hidden="true"></i> přeobjednat</button> -->
                                <button class="btn btn-sm btn-danger" @click="cancelVisitTask(visit.id)"><i class="fa fa-calendar-times-o" aria-hidden="true"></i> zrušit návštěvu</button>
                            </template><br>
                            {{ visit.planned_for.fullname }}
                            <i v-if="visit.planned_by && visit.planned_at" class="text-info fa fa-lg fa-info-circle" aria-hidden="true" v-tooltip="{
                                  content: 'naplánoval/a: <b>' + visit.planned_by.fullname + '</b><br>dne ' + visit.planned_at,
                                  placement: 'bottom-center',
                                  classes: ['info']}"></i>
                            <!-- <visit-change-doctor v-on:update="getDoctorsDayVisits" :doctors="doctors" :selected-doctor-id="visit.planned_for.id" :visit-id="visit.id"></visit-change-doctor> -->
                        </td>
                    </tr>
                    <tr v-if="showedVisitDetail.indexOf(index) > -1">
                        <td class="border-top-0">

                        </td>
                      <td class="" colspan="2">
                          <div class="row m-0" v-if="visit.presenting_complaint">
                              <h6>{{ visit.presenting_complaint.anamnesis_type.name }}</h6>
                              <div v-html="visit.presenting_complaint.text"></div>
                          </div>
                          <div class="" v-else-if="visit.medical_report">
                              <h6>Výsledná zpráva</h6>
                              <div v-html="visit.medical_report.text"></div>
                          </div>
                      </td>
                        <td class="" colspan="2">
                            <div class="">
                                <h6>Diagnózy a výkony</h6>
                                <div>
                                    <table class="table">
                                        <tbody>
                                        <template v-for="diagnose in visit.diagnosis">
                                            <tr>
                                                <td>{{ diagnose.disease.code }}</td>
                                                <td>{{ diagnose.disease.name_cs }}</td>
                                            </tr>
                                            <template v-if="diagnose.actions.length > 0">
                                                <template v-for="action in diagnose.actions">
                                                    <tr>
                                                        <td></td>
                                                        <td>
                                                            {{ action.operation.code }} - {{ action.operation.name }}
                                                        </td>
                                                    </tr>
                                                    <template v-if="action.zulp.length > 0">
                                                        <tr v-for="zulp in action.zulp">
                                                            <td></td>
                                                            <td>
                                                                &nbsp;&nbsp;&nbsp;zulp: {{ zulp.amount }}x {{ zulp.medicine.label }}
                                                            </td>
                                                        </tr>
                                                    </template>
                                                    <template v-if="action.zum.length > 0">
                                                        <tr v-for="zum in action.zum">
                                                            <td></td>
                                                            <td>
                                                                &nbsp;&nbsp;&nbsp;zum: {{ zum.amount }}x {{ zum.material.label }}
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-else="">
                                                <tr>
                                                    <td></td>
                                                    <td>
                                                        <i>(diagnóza nemá přidělené výkony)</i>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="">
                                <h6>Léčiva</h6>
                                <div>
                                    <template v-if="visit.medicament.length > 0">
                                        <table class="table">
                                            <tbody>
                                            <tr v-for="m in visit.medicament">
                                                <td>{{ m.medicine ? m.medicine.label : '' }}
                                                  {{ m.individual_medicine ? m.individual_medicine.name : '' }}</td>
                                                <td>{{ m.dosage }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </template>
                                    <template v-else="">
                                        <i>žádný lék nepředepsán</i>
                                    </template>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div class="card-body" v-else-if="visitsPending">
            <div class="text-center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
                (načítám)
            </div>
        </div>
        <div class="card-body" v-else="">
            <div class="text-center">
                <i class="fa fa-frown-o fa-3x"></i><br/>
                (na tento den není nic naplánováno)
            </div>
        </div>
        <client-task-add :opened="modalAddVisitOpened" v-on:update="updateVisits"></client-task-add>
    </div>
</template>

<script>
  import ClientTaskAdd from '../modals/AddTask.vue'
  import apiMixin from '@/mixins'

  import VisitTaskChangeStateReceptionist from '@/views/HomeReceptionist/components/VisitTaskChangeState.vue'
  import VisitTaskChangeStateDoctor from '@/views/HomeDoctor/components/VisitTaskChangeState.vue'

  export default {
    data () {
      return {
        hostname: require('@/variables.js'),
        selectedStates: [
          'scheduled',
          'arrived',
          'elaborated',
          'completed'
        ],
        visits: [],
        visitsPending: false,
        visitsError: false,
        past_visits: '',
        show_past_visits: false,
        neco_se_stalo_s_id: '',
        modalAddVisitOpened: false,
        modalAddVisitNowOpened: false,
        modalChangeVisitOpened: false,
        modalChangeVisitId: null,
        changePending: false,
        update_visit: {},
        showedVisitDetail: [],
        editingVisitId: false,
        editingVisit: {},
        waitForSave: false
      }
    },
    mixins: [apiMixin],
    props: ['doUpdate'],
    methods: {
      hasRole (role) {
        let roles = JSON.parse(this.$ls.get('role'))
        for (let i = 0; i < roles.length; i++) {
          if (roles[i] === role) {
            return true
          }
        }
        return false
      },
      editVisit (note, id) {
        this.editingVisitId = id
        this.editingVisit = {
          note: note
        }
      },
      putVisit () {
        this.waitForSave = true
        this.$http.put('visit_task/' + this.editingVisitId, this.editingVisit, {emulateJSON: true}).then(response => {
          this.waitForSave = false
          this.editingVisitId = false
          this.editingVisit = {}
          this.updateVisits()
        }, response => {
          this.errors = response.data.errors
          this.waitForSave = false
        })
      },
      showHideVisitDetail (index) {
        if (this.showedVisitDetail.indexOf(index) === -1) {
          this.showedVisitDetail.push(index)
        } else {
          this.showedVisitDetail.splice(this.showedVisitDetail.indexOf(index), 1)
        }
      },
      showPastVisits () {
        this.show_past_visits = true
        if (this.past_visits === '') {
          this.getClientsPastVisits()
        }
      },
      cancelVisitTask (visitId) {
        this.changePending = true
        this.update_visit.state = 'canceled'
        this.$http.put('visit_task/' + visitId, this.update_visit, {emulateJSON: true}).then(response => {
          this.submited = response.data
          this.changePending = false
          this.updateVisits('home')
        }).catch(error => {
          this.changeError = error.response.data.errors
          this.changePending = false
        })
      },
      hidePastVisits () {
        this.show_past_visits = false
      },
      changeState (id) {
        this.neco_se_stalo_s_id = id
      },
      clientVisitsUpdated () {
        this.$emit('updated')
      },
      showModal (name) {
        this.$modal.show(name)
      },
      showModalClientVisitChange (visitId) {
        this.modalChangeVisitOpened = true
        this.modalChangeVisitId = visitId
        this.showModal('client-visit-change')
      },
      showModalClientTaskAdd () {
        this.modalAddVisitOpened = true
        this.showModal('client-task-add')
      },
      showModalClientVisitNowAdd () {
        this.modalAddVisitNowOpened = true
        this.showModal('client-visit-now-add')
      },
      updateVisits () {
        this.getClientsVisitTasks(this.selectedStates, this.$route.params.clientid)
        /* this.getClientsUpcomingVisits()
        if (this.show_past_visits === true || this.past_visits !== '') {
          this.getClientsPastVisits()
        }
        this.clientVisitsUpdated() */
      }
    },
    beforeMount () {
      this.updateVisits()
    },
    watch: {
      doUpdate (val) {
        if (val === true) {
          this.updateVisits()
        }
      },
      selectedStates: function () {
        this.updateVisits()
      },
      '$route' (to, from) {
        if (to.params.clientid !== from.params.clientid && typeof (to.params.clientid) !== 'undefined') {
          this.updateVisits()
        }
      }
    },
    components: {
      ClientTaskAdd,
      VisitTaskChangeStateReceptionist,
      VisitTaskChangeStateDoctor
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Client/components/ClientTask.vue?f31b5700